// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__Ey0pO","ssr-layout":"styles_ssr-layout__lJRSb","buttonsLayout":"styles_buttonsLayout__8DnR8"};